/* UPSPLUSBATTERY - product page shipping rate + column balance */
(function(){
  'use strict';

  /* ---------- 1. reference blocks go under the image on desktop ----------
     .product is a flex row and media/info are siblings, so CSS cannot move a
     child of the info column into the media column. The image leaves a tall
     empty gap, so the long reference blocks live there and the buy column
     stays short. Mobile is one column with the media FIRST, so we only do this
     on desktop - otherwise the spec table would sit above Add to cart. */
  var MOVE = ['.upsb-purchase-summary', '.upsb-pdp-trust'];
  var BP = 990;

  function shelf(){
    var media = document.querySelector('.product__media-wrapper');
    if (!media) return null;
    var s = media.querySelector('.upsb-shelf');
    if (!s){ s = document.createElement('div'); s.className = 'upsb-shelf'; media.appendChild(s); }
    return s;
  }
  function relocate(){
    var s = shelf(); if (!s) return;
    var wide = window.innerWidth >= BP;
    MOVE.forEach(function(sel){
      var el = document.querySelector(sel); if (!el) return;
      if (wide){
        if (el.parentElement !== s){ el.dataset.upsbMoved = '1'; s.appendChild(el); }
      } else if (el.dataset.upsbMoved === '1'){
        var info = document.querySelector('.product__info-container');
        if (info){ info.appendChild(el); delete el.dataset.upsbMoved; }
      }
    });
    s.hidden = !s.children.length;
    // 8 Oct 2026 (Christian: "when scrolling down, the text disappears"): the gallery above the shelf is sticky
    // (section-main-product.css), so the shelf scrolled up underneath it. While the shelf holds blocks, the gallery
    // scrolls with the page.
    var media = document.querySelector('.product__media-wrapper');
    if (media) media.classList.toggle('upsb-has-shelf', wide && s.children.length > 0);
  }
  /* 16 Oct 2026: this timer was named t, the same name as the translator t() below; the first resize (or phone rotation)
     turned t into a number and Get rates then failed with "t is not a function", leaving the button disabled. */
  var relocTimer; function schedule(){ clearTimeout(relocTimer); relocTimer = setTimeout(relocate, 60); }

  /* ---------- 2. rate calculator ---------- */
  /* CAP is matched against Shopify's rate NAMES, which are English whatever the
     storefront locale is. It is a matcher, not copy - never translate it. */
  var CAP = 'Guaranteed maximum';

  /* The widget writes its text at runtime, so it has to speak the page's
     language. Detected from <html lang> first, then the /fr path prefix.
     Quebec French, and no em dashes in it (house rule). */
  var STR = {
    en: {
      toggle: 'Calculate shipping', postal: 'Postal code', province: 'Province', go: 'Get rates',
      contact_url: '/pages/contact',
      asking: 'Asking the carriers…',
      still: 'Still waiting for the carriers…',
      enter_postal: 'Enter a full postal code.',
      bad_postal: 'Check the postal code: the carriers did not recognise it.',
      choose_option: 'Choose an option first.',
      unreachable: 'Could not reach the carriers. Please try again.',
      no_quote: 'We cannot quote this item online.',
      ask_text: 'Ask us for a freight quote',
      ask_tail: '. We usually reply the same business day.',
      adds_nothing: 'Adds <b>nothing</b> to your shipping.',
      adds_amount: 'Adds <b>%AMOUNT%</b> to your shipping.',
      cart_total_prefix: 'Total for everything in your cart. ',
      live_rate: 'Live carrier rate to this postal code.',
      pallet_rate: 'Pallet freight estimate. Checkout sets the final rate from your full address.'
    },
    fr: {
      toggle: 'Calculer la livraison', postal: 'Code postal', province: 'Province', go: 'Obtenir les tarifs',
      contact_url: '/fr/pages/contact',
      asking: 'Interrogation des transporteurs…',
      still: 'Toujours en attente des transporteurs…',
      enter_postal: 'Entrez un code postal complet.',
      bad_postal: 'Vérifiez le code postal : les transporteurs ne l’ont pas reconnu.',
      choose_option: 'Choisissez d’abord une option.',
      unreachable: 'Impossible de joindre les transporteurs. Veuillez réessayer.',
      no_quote: 'Nous ne pouvons pas coter cet article en ligne.',
      ask_text: 'Demandez une soumission de transport',
      ask_tail: '. Nous répondons généralement le jour ouvrable même.',
      adds_nothing: 'N’ajoute <b>rien</b> à vos frais de livraison.',
      adds_amount: 'Ajoute <b>%AMOUNT%</b> à vos frais de livraison.',
      cart_total_prefix: 'Total pour tout votre panier. ',
      live_rate: 'Tarif transporteur en direct pour ce code postal.',
      pallet_rate: 'Estimation du transport sur palette. Le tarif final est calculé à la caisse avec votre adresse complète.'
    }
  };
  var LANG = (function(){
    var l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (l.indexOf('fr') === 0) return 'fr';
    var p = location.pathname;
    return (p === '/fr' || p.indexOf('/fr/') === 0) ? 'fr' : 'en';
  })();
  var I18N = STR[LANG];
  function t(k, fb){ var v = I18N[k]; return (typeof v === 'string' && v.length) ? v : fb; }
  /* The block still renders these four in English; retitle them here so the
     whole widget matches the page. */
  (function localiseChrome(){
    if (LANG === 'en') return;
    var r = document.querySelector('[data-upsb-ship]');
    if (!r) return;
    var b = r.querySelector('[data-ship-toggle]'); if (b) b.textContent = I18N.toggle;
    var z = r.querySelector('[data-ship-zip]');
    if (z) { z.setAttribute('placeholder', I18N.postal); z.setAttribute('aria-label', I18N.postal); }
    var p = r.querySelector('[data-ship-prov]'); if (p) p.setAttribute('aria-label', I18N.province);
    var g = r.querySelector('[data-ship-go]'); if (g) g.textContent = I18N.go;
  })();

  var TTL = 6 * 60 * 60 * 1000;

  /* Buyer-journey #5 (7 Oct 2026): the province follows the postal code. A BC code sent with the default QC came back
     422 and read as "cannot quote". X0A-X0C = Nunavut, other X = NWT. */
  var FSA = {A:'NL',B:'NS',C:'PE',E:'NB',G:'QC',H:'QC',J:'QC',K:'ON',L:'ON',M:'ON',N:'ON',P:'ON',R:'MB',S:'SK',T:'AB',V:'BC',Y:'YT'};
  function provFromZip(zip){
    var z = String(zip || '').replace(/\s+/g,'').toUpperCase();
    if (!/^[A-Z]\d[A-Z]/.test(z)) return null;
    if (z[0] === 'X') return /^X0[ABC]/.test(z) ? 'NU' : 'NT';
    return FSA[z[0]] || null;
  }

  /* Carrier rates through Shopify's async endpoints (prepare, then poll); the legacy sync endpoint gave up on slow
     carriers. Resolves {ok, rates, bad}: bad = the postal code was rejected; ok false = timed out or unreachable. */
  function wait(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }
  function ratesFor(prov, zip){
    var q = 'shipping_address%5Bcountry%5D=Canada' +
            '&shipping_address%5Bprovince%5D=' + encodeURIComponent(prov) +
            '&shipping_address%5Bzip%5D=' + encodeURIComponent(zip.replace(/\s+/g,''));
    var t0 = Date.now();
    function poll(){
      return fetch('/cart/async_shipping_rates.json?' + q).then(function(r){
        if (r.status === 422) return {ok:false, rates:[], bad:true};
        if (r.status === 200) return r.json().then(function(b){
          if (b && b.shipping_rates) return {ok:true, rates:b.shipping_rates};
          return Date.now() - t0 > 25000 ? {ok:false, rates:[]} : wait(800).then(poll);
        });
        if (r.status === 202 && Date.now() - t0 <= 25000) return wait(800).then(poll);
        return {ok:false, rates:[]};
      });
    }
    return fetch('/cart/prepare_shipping_rates.json?' + q, {method:'POST'})
      .then(function(r){ return r.status === 422 ? {ok:false, rates:[], bad:true} : poll(); })
      .catch(function(){ return {ok:false, rates:[]}; });
  }
  function cheapest(list){
    var c = list.filter(function(o){ return o.name.indexOf(CAP) === -1; });
    var use = c.length ? c : list;
    if (!use.length) return null;
    return use.reduce(function(a,b){ return Number(b.price) < Number(a.price) ? b : a; });
  }

  function init(){
    var root = document.querySelector('[data-upsb-ship]');
    if (!root || root.dataset.upsbShipInit) return;
    root.dataset.upsbShipInit = '1';

    var toggle = root.querySelector('[data-ship-toggle]'),
        panel  = root.querySelector('[data-ship-panel]'),
        zipEl  = root.querySelector('[data-ship-zip]'),
        provEl = root.querySelector('[data-ship-prov]'),
        goEl   = root.querySelector('[data-ship-go]'),
        outEl  = root.querySelector('[data-ship-out]');

    try {
      var z = localStorage.getItem('upsb_zip'), p = localStorage.getItem('upsb_prov');
      if (z) zipEl.value = z; if (p) provEl.value = p;
    } catch(e){}
    function syncProv(){ var pv = provFromZip(zipEl.value); if (pv && provEl.querySelector('option[value="' + pv + '"]')) provEl.value = pv; }
    syncProv();
    zipEl.addEventListener('input', syncProv);
    zipEl.addEventListener('change', syncProv);

    toggle.addEventListener('click', function(){
      var open = panel.hidden;
      panel.hidden = !open; root.classList.toggle('is-open', open);
      if (open) zipEl.focus();
    });

    /* 16 Oct 2026 (code audit #6): the quantity box sits outside the buy form and joins it with form="product-form-...",
       so a lookup inside the form found nothing and every estimate priced one unit. The buy form is the one the
       quantity box names (the first "product-form-" form on the page is Shop Pay's installments form), and its id is
       read with getAttribute: the form holds an input named "id", so form.id is that input. */
    function qtyInput(){ return document.querySelector('input.quantity__input[name="quantity"][form]'); }
    function mainForm(){
      var q = qtyInput(), f = q ? document.getElementById(q.getAttribute('form')) : null;
      return (f && f.matches('form[action*="/cart/add"]')) ? f :
             document.querySelector('product-form form[action*="/cart/add"]') ||
             document.querySelector('form[action*="/cart/add"]');
    }
    function variantId(){
      var f = mainForm(), i = f && f.querySelector('[name="id"]');
      return i ? i.value : null;
    }
    function qty(){
      var q = qtyInput(), f = mainForm();
      if (!q && f) q = f.querySelector('[name="quantity"]');
      var n = q ? parseInt(q.value,10) : 1; return (n && n > 0) ? n : 1;
    }

    /* 16 Oct 2026 (code audit #10): carriers only rate a real cart, so the estimate puts this item in the cart for a few
       seconds and then takes that line back out. An Add to cart pressed in that window was undone by the clean-up. While
       the estimate holds the cart, an Add to cart waits (button shows its spinner) and goes through once the line is back. */
    var holding = false, queued = [], holdTimer = null;
    /* the hold covers the whole estimate (two carrier waits of at most 25 s each); a stalled network call releases it
       after 60 s, and the clean-up below then works from a fresh read of the cart, so a late Add to cart still survives */
    function hold(){ holding = true; clearTimeout(holdTimer); holdTimer = setTimeout(release, 60000); }
    function spin(b, on){
      if (!b) return;
      b.classList.toggle('loading', on);
      if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      var sp = b.querySelector('.loading__spinner'); if (sp) sp.classList.toggle('hidden', !on);
    }
    document.addEventListener('submit', function(e){
      if (!holding) return;
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var b = (e.submitter && e.submitter.form === f) ? e.submitter : f.querySelector('[type="submit"]');
      spin(b, true);
      if (!queued.some(function(x){ return x.form === f; })) queued.push({form:f, btn:b});
    }, true);
    function release(){
      clearTimeout(holdTimer);
      holding = false;
      var q = queued; queued = [];
      q.forEach(function(x){
        spin(x.btn, false);
        if (x.form.requestSubmit) x.form.requestSubmit(x.btn || undefined);
        else x.form.dispatchEvent(new Event('submit', {bubbles:true, cancelable:true}));
      });
    }
    function money(n){ return LANG === 'fr' ? Number(n).toFixed(2).replace('.', ',') + ' $' : '$' + Number(n).toFixed(2); }
    /* full postal code, never the FSA: rates measurably differ inside one FSA
       (J4W 1B2 = GLS $13.81 vs J4W 3K5 = Canpar $13.53) */
    function key(v,n,z,p){ return 'upsb_r_' + v + '_' + n + '_' + p + '_' + String(z).replace(/\s+/g,'').toUpperCase(); }
    function cGet(k){ try{ var v=JSON.parse(localStorage.getItem(k)||'null');
      return (v && (Date.now()-v.t) < TTL) ? v.d : null; }catch(e){ return null; } }
    function cSet(k,d){ try{ localStorage.setItem(k, JSON.stringify({t:Date.now(),d:d})); }catch(e){} }
    function post(u,b){ return fetch(u,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(b)}); }

    function render(d){
      if (!d.rates.length){
        outEl.innerHTML = '<p class="upsb-ship__err">' + t('no_quote', 'We cannot quote this item online.') + '</p>' +
          '<p class="upsb-ship__note"><a href="' + I18N.contact_url + '">' +
          t('ask_text', 'Ask us for a freight quote') + '</a>' +
          t('ask_tail', '. We usually reply the same business day.') + '</p>';
        return;
      }
      var list = d.rates.filter(function(o){ return o.name.indexOf(CAP) === -1; });
      if (!list.length) list = d.rates;
      list = list.slice().sort(function(a,b){ return Number(a.price)-Number(b.price); }).slice(0,3);
      /* ClickShip's LTL rate ("Pallet Rate-1", a matcher like CAP) is priced from the postal code alone here; with the
         full address at checkout it can come out lower (8 Oct 2026: V6B 551.07 here, 217.22 with the street), so it is
         labelled an estimate. */
      var pallet = list.some(function(o){ return /^Pallet/i.test(o.name); });

      var head = '';
      if (d.delta !== null && d.delta !== undefined){
        head = '<p class="upsb-ship__delta">' +
               (Number(d.delta) <= 0.005
                 ? t('adds_nothing', 'Adds <b>nothing</b> to your shipping.')
                 : t('adds_amount', 'Adds <b>%AMOUNT%</b> to your shipping.')
                     .replace('%AMOUNT%', money(d.delta))) +
               '</p>';
      }
      outEl.innerHTML = head +
        '<ul class="upsb-ship__list">' + list.map(function(o,i){
          return '<li class="upsb-ship__opt' + (i===0?' is-best':'') + '">' +
                 '<span>' + o.name.split(' — ')[0] + '</span>' +
                 '<b>' + money(o.price) + '</b></li>';
        }).join('') + '</ul>' +
        '<p class="upsb-ship__note">' +
          (d.combined ? t('cart_total_prefix', 'Total for everything in your cart. ') : '') +
          (pallet ? t('pallet_rate', 'Pallet freight estimate. Checkout sets the final rate from your full address.')
                  : t('live_rate', 'Live carrier rate to this postal code.')) + '</p>';
    }

    var busy = false;
    function run(){
      if (busy) return;
      var zip = (zipEl.value||'').trim();
      if (zip.replace(/\s+/g,'').length < 6){
        outEl.innerHTML = '<p class="upsb-ship__err">' + t('enter_postal', 'Enter a full postal code.') + '</p>'; return; }
      var vid = variantId();
      if (!vid){ outEl.innerHTML = '<p class="upsb-ship__err">' + t('choose_option', 'Choose an option first.') + '</p>'; return; }
      syncProv();
      var n = qty(), prov = provEl.value;
      try{ localStorage.setItem('upsb_zip',zip); localStorage.setItem('upsb_prov',prov); }catch(e){}

      var k = key(vid,n,zip,prov), hit = cGet(k);
      if (hit){ render(hit); return; }

      busy = true; goEl.disabled = true; hold();
      outEl.innerHTML = '<p class="upsb-ship__loading">' + t('asking', 'Asking the carriers…') + '</p>';
      var slow = setTimeout(function(){
        var l = outEl.querySelector('.upsb-ship__loading'); if (l) l.textContent = t('still', 'Still waiting for the carriers…');
      }, 7000);
      function fail(bad){
        outEl.innerHTML = '<p class="upsb-ship__err">' + (bad ? t('bad_postal', 'Check the postal code: the carriers did not recognise it.')
          : t('unreachable', 'Could not reach the carriers. Please try again.')) + '</p>';
      }

      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(before){
        var combined = before.item_count > 0;

        /* the cart as it stands - needs NO mutation, so it is a free read */
        var basePromise = combined ? ratesFor(prov, zip).then(function(b){ return b.ok ? cheapest(b.rates) : null; }) : Promise.resolve(null);

        return basePromise.then(function(base){
          return post('/cart/add.js', {items:[{id:Number(vid), quantity:n}]})
            .then(function(r){ return r.ok ? r.json().catch(function(){ return {unread:true}; }) : null; }, function(){ return null; })
            .then(function(added){
              if (!added) return {ok:false, rates:[]};
              /* the line the add touched, by its key: a line of the same variant with properties (a Builder solution)
                 is a different line and stays as it is. An unreadable answer falls back to the variant, as before. */
              var line = added.items && added.items[0];
              var key = (line && line.key) ? line.key : null;
              return ratesFor(prov, zip).then(function(res){
                /* take back exactly the n units this estimate added, whatever the carriers said, from the cart as it is
                   now (anything else added meanwhile stays); the cart is never cleared */
                return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(now){
                  var cur = null;
                  now.items.forEach(function(i){ if (key ? i.key === key : (!cur && String(i.variant_id) === String(vid))) cur = i; });
                  if (!cur) return res;
                  return post('/cart/change.js', {id:cur.key, quantity: Math.max(0, cur.quantity - n)});
                }).then(function(){ return res; }, function(){ return res; });
              });
            })
            .then(function(res){
              if (!res.ok) { fail(res.bad); return; }
              var withIt = cheapest(res.rates);
              var delta = (base && withIt) ? Math.max(0, Number(withIt.price) - Number(base.price)) : null;
              var d = {rates:res.rates, combined:combined, delta:delta};
              if (res.rates.length) cSet(k, d);
              render(d);
              document.dispatchEvent(new CustomEvent('upsb:rates',
                {detail:{variant:vid, zip:zip, count:res.rates.length, delta:delta}}));
            });
        });
      }).catch(function(){ fail(false); }).then(function(){ clearTimeout(slow); busy = false; goEl.disabled = false; release(); });
    }

    goEl.addEventListener('click', run);
    zipEl.addEventListener('keydown', function(e){ if (e.key==='Enter'){ e.preventDefault(); run(); } });
  }

  /* ---------- 3. STAGING SHIM (2026-09-24) ----------
     Previews two product-page changes whose real home is sections/main-product.liquid
     (patch in the upsplusbattery repo, content/catalog/2026-09-24-improvements/): the fit
     guarantee and the quantity-field label. It does nothing once the Liquid version renders;
     remove it after that file is pushed. Also names the Google store-widget iframe. */
  function shim(){
    var box = document.querySelector('.upsb-purchase-summary');
    if (box && !box.querySelector('.upsb-purchase-summary__fit') && box.querySelector('.upsb-purchase-summary__models')){
      var ret = box.querySelector('.upsb-purchase-summary__returns');
      if (ret){
        var fit = document.createElement('p');
        fit.className = 'upsb-purchase-summary__returns upsb-purchase-summary__fit';
        fit.innerHTML = (LANG === 'fr')
          ? '<strong>Compatibilité garantie pour les modèles indiqués.</strong> Si cette batterie ne convient pas à un modèle UPS indiqué sur cette page, nous payons le retour et vous envoyons la bonne batterie ou vous remboursons, à votre choix.'
          : '<strong>Fit guaranteed for the models listed.</strong> If this battery does not fit a UPS model listed on this page, we pay return shipping and send the correct battery or refund you, your choice.';
        ret.parentNode.insertBefore(fit, ret);
      }
    }
    var q = document.querySelector('input.quantity__input[id^="Quantity-"]');
    if (q && !q.hasAttribute('aria-labelledby')){
      var lab = document.querySelector('[id^="quantity-label-"]');
      if (lab) q.setAttribute('aria-labelledby', lab.id);
    }
  }
  function nameWidgetFrame(){
    var title = (LANG === 'fr') ? 'Évaluation de la boutique sur Google' : 'Google store rating';
    function apply(){
      var f = document.getElementById('merchantwidgetiframe');
      if (f && !f.getAttribute('title')){ f.setAttribute('title', title); return true; }
      return !!f;
    }
    if (apply() || !window.MutationObserver) return;
    var mo = new MutationObserver(function(){ if (apply()) mo.disconnect(); });
    mo.observe(document.body, {childList:true, subtree:true});
    setTimeout(function(){ mo.disconnect(); }, 20000);
  }

  function boot(){ shim(); nameWidgetFrame(); init(); relocate(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('resize', schedule);
  var info = document.querySelector('.product__info-container');
  if (info && window.MutationObserver) new MutationObserver(schedule).observe(info, {childList:true});
})();